// import '../styles.css'
import '../scss/main.scss'
import './legacy/src/js/main'
import './index'
